import { useModuleBEM } from "@b2bportal/core-themes";
import { SkeletonLoading } from "@tenant/ui";
import clsx from "clsx";

import styles from "./OfferCardSkeleton.module.scss";

export interface OfferCardSkeletonProps {
  className?: string;
}

/**
 * Placeholder that mirrors the stacked HotelCard shape (image on top, then a
 * few text rows) while the offer list loads.
 */
export const OfferCardSkeleton = ({ className }: OfferCardSkeletonProps) => {
  const [block, cn] = useModuleBEM(styles, "OfferCardSkeleton");

  return (
    <div className={clsx(block, className)} aria-hidden="true">
      <SkeletonLoading className={cn("image")} />
      <div className={cn("body")}>
        <SkeletonLoading className={cn("pre-title")} />
        <SkeletonLoading className={cn("title")} />
        <SkeletonLoading className={cn("feature")} />
        <SkeletonLoading className={cn("feature")} />
        <SkeletonLoading className={cn("price")} />
      </div>
    </div>
  );
};
